import GerenciadorCTeService from "@/services/GerenciadorCTeService";

function normalizeError(error) {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim() !== "") {
    return { Message: data };
  }

  if (data) {
    return data;
  }

  if (typeof error === "string" && error.trim() !== "") {
    return { Message: error };
  }

  if (error?.message) {
    return { Message: error.message };
  }

  return { Message: "Nao foi possivel concluir a operacao." };
}

export const gerenciadorCTe = {
  namespaced: true,
  state: {
    gerenciadorCTe: {},
  },
  actions: {
    padroesDisponiveis({ commit }, payload) {
      return GerenciadorCTeService.PadroesDisponiveis(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    transmitirNota({ commit }, payload) {
      return GerenciadorCTeService.TransmitirNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    consultarNota({ commit }, payload) {
      return GerenciadorCTeService.ConsultarNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    cancelarNota({ commit }, payload) {
      return GerenciadorCTeService.CancelarNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    imprimirNota({ commit }, payload) {
      return GerenciadorCTeService.ImprimirNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    preVisualizarNota({ commit }, payload) {
      return GerenciadorCTeService.PreVisualizarNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    downloadXMLCTe({ commit }, payload) {
      return GerenciadorCTeService.DownloadXMLCTe(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
  },
  mutations: {},
};

export default gerenciadorCTe;
